import {$, T} from "../../common/drupal/drupal";

class ParagraphProducts {

    /**
     * Initialize event listeners
     */
    init () {
        // slide Paragraph products
        let slideProductsId = 0;
        let slideProducts = [];
        $('.ProductList-products:not(.NodeHome-products-products)').each(function () {
            if($(this).find('.swiper-wrapper').length < 1) {
                $(this).addClass('swiper-container').find('.ProductList-item').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"/>');
                $(this).append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
                var homeSlide = new Swiper($(this), {
                    slidesPerView: 1,
                    speed: 500,
                    watchOverflow: true,
                    watchSlidesVisibility: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        }
                    }
                });
                slideProductsId++;
            }
        });
    }

    attach(context) {
        this.init(context);
    }
}

export let paragraphProducts = new ParagraphProducts();
